import React, { useContext } from "react";
import {
  Box,
  Typography,
  Chip,
  Grid,
} from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { MultipleTestCasesContext } from "../../main-pages/MultiTestCaseGenerationPage";
import { useNavigate } from "react-router-dom";

const SelectedTestingTypesComponent = () => {
  const { selectedTestingTypes } = useContext(MultipleTestCasesContext);
  const navigate = useNavigate();

  if (!selectedTestingTypes || selectedTestingTypes.length === 0) {
    return null;
  }

  const handleEditTestingTypes = () => {
    navigate("/dashboard/generate-multi/testcases/select-testing-types", { replace: true });
  };

  // Group testing types by category
  const functionalTypes = selectedTestingTypes.filter(
    (type) => type.type === "functional"
  );
  const nonFunctionalTypes = selectedTestingTypes.filter(
    (type) => type.type === "non-functional"
  );

  const buttons = [
    {
      label: "Edit Testing Types",
      variant: "contained",
      onClick: handleEditTestingTypes,
      sx: { float: "right" },
    },
  ];

  return (
    <Box sx={{ width: { xs: '100%', md: 966, lg: 1100 } }}>
      <CommonAccordion
        summary={`Selected Testing Types (${selectedTestingTypes.length})`}
        details={
          <Box>
            <Grid container spacing={2}>
              {functionalTypes.length > 0 && (
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: "#1976d2",
                      mb: 1,
                      fontSize: "14px",
                    }}
                  >
                    Functional Testing Types ({functionalTypes.length})
                  </Typography>
                  <Box 
                    sx={{ 
                      display: "flex", 
                      flexWrap: "wrap", 
                      gap: 1,
                      maxHeight: "200px",
                      overflowY: "auto",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                        borderRadius: "3px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#c1c1c1",
                        borderRadius: "3px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#a8a8a8",
                      },
                    }}
                  >
                    {functionalTypes.map((type, index) => (
                      <Chip
                        key={index}
                        label={type.name}
                        color="primary"
                        variant="outlined"
                        size="small"
                        sx={{
                          fontSize: "12px",
                          height: "28px",
                          minWidth: "fit-content",
                        }}
                      />
                    ))}
                  </Box>
                </Grid>
              )}
              {nonFunctionalTypes.length > 0 && (
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: "#d32f2f",
                      mb: 1,
                      fontSize: "14px",
                    }}
                  >
                    Non-Functional Testing Types ({nonFunctionalTypes.length})
                  </Typography>
                  <Box 
                    sx={{ 
                      display: "flex", 
                      flexWrap: "wrap", 
                      gap: 1,
                      maxHeight: "200px",
                      overflowY: "auto",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                        borderRadius: "3px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#c1c1c1",
                        borderRadius: "3px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#a8a8a8",
                      },
                    }}
                  >
                    {nonFunctionalTypes.map((type, index) => (
                      <Chip
                        key={index}
                        label={type.name}
                        color="error"
                        variant="outlined"
                        size="small"
                        sx={{
                          fontSize: "12px",
                          height: "28px",
                          minWidth: "fit-content",
                        }}
                      />
                    ))}
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        }
        buttons={buttons}
        type={"output"}
        fullScreenMode={true}
        defaultExpanded={false}
      />
    </Box>
  );
};

export default SelectedTestingTypesComponent;